export const cols = [{
	prop: 'orderType',
	label: '单据类型',
	width: '180',
	align: 'center'
}, {
	prop: 'entName',
	label: '供货商名称',
	width: '180',
	align: 'center'
}, {
	prop: 'shopName',
	label: '供货商店铺名称',
	width: '180',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'buyer',
	label: '采购门店名称',
	width: '180',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'store',
	label: '收货仓库',
	width: '180',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'bigCate',
	label: '商品大类',
	width: '180',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'samllCate',
	label: '商品小类',
	width: '180',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'pname',
	label: '商品名称',
	width: '180',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'specs',
	label: '规格',
	width: '120',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'punit',
	label: '单位',
	width: '120',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'itemquantity',
	label: '订货总数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendCount',
	label: '实发总数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendDiffCount',
	label: '实发差异总数量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getCount',
	label: '实收总数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getDiffCount',
	label: '实收差异总数量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'avgPrice',
	label: '平均单价',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'itemmoney',
	label: '订货总金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendPrice',
	label: '实发总金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendDiffPrice',
	label: '实发差异总金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getPrice',
	label: '实收总金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getDiffPrice',
	label: '实收差异总金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundCount',
	label: '退单数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundPrice',
	label: '退单金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}]
